import type { ResolvedBranding } from '@command-center/ui-system';
import { config } from '../portal.config';

/**
 * Builds the branding shape consumed by the shared ui-system Sidebar/Header
 * and ThemeProvider from the Client Portal's portal.config.
 */
export function getBranding(): ResolvedBranding {
  const branding = config.branding;
  return {
    name: branding.name || 'One Up Client Portal',
    logoSrc: branding.logo,
    iconSrc: branding.iconSrc,
    shortLabel: config.clientName || 'One Up',
    iconText: branding.icon || '1U',
    shortSuffix: 'Portal',
    colors: branding.colors,
  };
}
